<div>
    <div class="identifier-heading-wrapper">
        <h1 appHeading isHuge>
            {{ tabletIdentifier$ | async }}
        </h1>
        <span class="regenerate-icon" (click)="regenerateIdentifier()">
            <mat-icon>refresh</mat-icon>
        </span>
    </div>

    <div class="identifier-info">
        @if (currentTabletMessage$ | async; as tabletMessage) {
            <a appButton
               *ngIf="!error"
                (click)="finalizeConfiguration()"
            >
                Configuratie verifieren
            </a>
        } @else {
            <mat-icon>info</mat-icon>
            <p appParagraph>
                Om deze tablet te configureren voert u de bovenstaande code in bij tablet beheer in ACE.
            </p>
        }

        @if (error) {
            <mat-icon>info</mat-icon>
            <p *ngIf="error" appParagraph>
                {{error}}
            </p>
        }
    </div>
</div>
